import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import MovieCategoryPage from "@/pages/category/movie/page";
import NovelCategoryPage from "@/pages/category/novel/page";
import NewsCategoryPage from "@/pages/category/news/page";
import MovieDetailPage from "@/pages/detail/movie/page";
import NovelDetailPage from "@/pages/detail/novel/page";
import NewsDetailPage from "@/pages/detail/news/page";
import SearchPage from "@/pages/search/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/movie", element: <MovieCategoryPage /> },
      { path: "category/novel", element: <NovelCategoryPage /> },
      { path: "category/news", element: <NewsCategoryPage /> },
      { path: "detail/movie/:id", element: <MovieDetailPage /> },
      { path: "detail/novel/:id", element: <NovelDetailPage /> },
      { path: "detail/news/:id", element: <NewsDetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;